import { enumToStaticValue } from '@/utils'

export enum InvoiceSeriesFormat {
  PREFIX_YYYY_NNNN = 'PREFIX_YYYY_NNNN',
  PREFIX_NNNN_YYYY = 'PREFIX_NNNN_YYYY'
}

export const invoiceSeriesFormats = enumToStaticValue(InvoiceSeriesFormat, 'invoice-series-format')
